import { Component, ViewEncapsulation, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ItemsService } from '../../../../services/items.service';
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import Swal from 'sweetalert2';
import { HomeService } from '../../../../services/home.service';
import { Stockitem } from '../../../../interfaces/stockitem';
import { users } from '../../../../interfaces/users';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { SelectedProductDetail } from '../../../../interfaces/addorder';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { OrdersService } from '../../../../services/orders';
import { GovernoratesService } from '../../../../services/governorates.service';

// Internal type aliases for readability (no runtime impact)
type StockItem = Stockitem;
type UserData = any;

@Component({
  selector: 'app-addorderwarehouse',
  templateUrl: './addorderwarehouse.component.html',
  styleUrl: './addorderwarehouse.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AddorderwarehouseComponent {
  // ===============================
  // UI State & Flags
  // ===============================
  contentReady = false;
  isMobile = false;
  isAr = false;
  isUpdate = false;
  inUpdatePage = false;
  displaybutton = false;
  clearClientBtn = false;
  clearcart = false;
  showAllUsers = false;
  warehouseIsStore = false;
  hasToken = false;
  hasQrOffer = false;
  classToggled = false;
  selectedValueFromStock = true;
  cartItems: any[] = [];
  searchValue = '';
  submitted = false;
  // ===============================
  // Form & Data Models
  // ===============================
  data!: FormGroup;
  dataForm!: FormData;


  // Client Information
  client_name = '';
  phone_number = '';
  another_phone = '';
  address = '';

  // Order Details
  delivery_fees = '';
  note = '';
  total = 0;
  income = 0;
  due: any = '';
  totalOriginalPrice = 0;
  totalUserEnteredPrice = 0;
  originalPrice = 0;
  bonus = 0;

  // Selection & Filtering
  selectedProduct: StockItem | null = null;
  selectedProductFromStock = '';
  selectedProductsDetails: SelectedProductDetail[] = [];
  productname: StockItem[] = [];
  productnamefixed: StockItem[] = [];
  filteredProviders: StockItem[] = [];
  users: UserData[] = [];
  governorates: any[] = [];
  cities: any[] = [];

  // Arrays for Order Submission
  arrayofitems: any[] = [];
  arrayofOlditems: any[] = [];
  arrayofqty: (number | null)[] = [];
  arrayofprices: (number | null)[] = [];
  arrayofids: (number | null)[] = [];
  arrayofbounes: number[] = [];

  // Location & Warehouse
  government_id: any = '';
  city_id: any = '';
  warehouseId: string | null = null;
  countryId!: number;
  selectedCountry: string | null = null;

  // User & Account
  userId = '';
  thisUserId: any = null;
  accounttype: string | null = null;
  createOrderByid: any = null;
  createOrderByidType: any = null;

  // Product Selection State
  productnameselectedvalu = 'select product';
  selectedProductLength = 0;
  productindex = 0;
  productqtyindex = 0;
  productpriceindex = 0;

  // Update Context
  updateId: any = null;

  // ===============================
  // View Children
  // ===============================
  @ViewChild('productSelect', { static: false }) productSelect!: ElementRef;
  @ViewChild('mySelect') mySelect!: MatSelect;

  // ===============================
  // Constructor
  // ===============================
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _homeService: HomeService,
    private _orderService: OrdersService,
    private _userService: UserService,
    private governoratesService: GovernoratesService,
    private deviceService: DeviceDetectorService
  ) { }

  // ===============================
  // Lifecycle
  // ===============================
  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem('language') === 'ar';
    this.hasToken = !!localStorage.getItem('token');
    this.warehouseId = localStorage.getItem('posId');
    this.accounttype = String(this.checkAccountType());
    this.loadWarehouseType();
    this.loadGovernorates();
    this.getUserId();
    this.displaybutton = this.arrayofitems.length !== 0;
    this.getAllStockData();
    this.getAllUsers();
    this.initiate();
    this.restoreCartFromStorage();
    this.restoreClientFromStorage();
    this.handleQueryParamCart();
  }
  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    this.searchValue = input.value;

    const search = input.value.toLowerCase();

    this.filteredProviders = this.productname.filter(p =>
      p.name_ar?.toLowerCase().includes(search)
    );
  }
  addProduct(event: any): void {

    const product = event.option.value;

    const exists = this.selectedProductsDetails.find(
      x => x.product.id === product.id
    );

    if (!exists) {

      this.selectedProductsDetails.push({
        product,
        quantity: 1,
        price: this.getProductPriceByAccountType(product),
        bounes: null
      });

    }

    this.searchValue = '';

  }
  removeProduct(id: number): void {

    this.selectedProductsDetails =
      this.selectedProductsDetails.filter(
        p => p.product.id !== id
      );

  }
  trackByProduct(index: number, item: any) {
    return item.product.id;
  }
  // ===============================
  // Price Calculation Helpers (Extracted)
  // ===============================
  private getProductPriceByAccountType(product: StockItem): number {
    switch (this.accounttype) {
      case '2': return Number(product.affiliationprice) ?? 0;
      case '3': return Number(product.pricea ?? 0);
      case '4': return Number(product.priceb ?? 0);
      case '5': return Number(product.pricec ?? 0);
      default: return Number(product.price ?? 0);
    }
  }

  // ===============================
  // Form Initialization
  // ===============================
  private initiate(): void {
    this.data = this.fb.group({
      client_name: ['', Validators.required],
      phone_number: [
        '',
        [
          Validators.required,
          this.realEgyptOrKsaPhoneValidator
        ],
      ],
      another_phone: [
        '',
        [
          this.realEgyptOrKsaPhoneValidator
        ],
      ],
      address: ['', Validators.required],
      quantity: [''],
      city_id: ['', Validators.required],
      government_id: ['', Validators.required],
      item: [''],
      createby: [''],
      price: [''],
      bounes: [''],
      delivery_fees: [''],
      note: [''],
      arrayofids: ['']
    });
  }

  // ===============================
  // Validator (Fixed Binding)
  // ===============================
  englishDigitsOnlyValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const arabicRegex = /[\u0600-\u06FF\u0660-\u0669\u06F0-\u06F9]/;
    return arabicRegex.test(control.value)
      ? { arabicNotAllowed: true }
      : null;
  };

  realEgyptOrKsaPhoneValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const rawValue = String(control.value).trim();
    const arabicRegex = /[\u0600-\u06FF\u0660-\u0669\u06F0-\u06F9]/;
    if (arabicRegex.test(rawValue)) {
      return { arabicNotAllowed: true };
    }

    const phone = rawValue.replace(/[\s\-()]/g, '');
    const egyptMobileRegex = /^(01[0125]\d{8}|\+201[0125]\d{8}|00201[0125]\d{8})$/;
    const ksaMobileRegex = /^(05\d{8}|\+9665\d{8}|009665\d{8})$/;

    return egyptMobileRegex.test(phone) || ksaMobileRegex.test(phone)
      ? null
      : { invalidEgyptOrKsaPhone: true };
  };

  shouldShowError(controlName: string): boolean {
    const control = this.data?.get(controlName);
    return !!control && control.invalid && (control.touched || this.submitted);
  }

  hasNoSelectedItems(): boolean {
    return this.selectedProductsDetails.length === 0 && this.cartItems.length === 0;
  }

  hasInvalidSelectedItems(): boolean {
    return this.selectedProductsDetails.some((item) => {
      const quantity = Number(item.quantity);
      const price = Number(this.warehouseIsStore ? item.bounes : item.price);
      return !Number.isFinite(quantity) || quantity < 1 || !Number.isFinite(price) || price < 0;
    });
  }

  shouldShowItemsError(): boolean {
    return this.submitted && this.hasNoSelectedItems();
  }

  shouldShowSelectedItemsError(): boolean {
    return this.submitted && !this.hasNoSelectedItems() && this.hasInvalidSelectedItems();
  }

  getErrorMessage(controlName: string, label: string): string {
    const control = this.data?.get(controlName);

    if (!control || !control.errors) {
      return '';
    }

    if (control.errors['required']) {
      return this.isAr ? `${label} مطلوب` : `${label} is required`;
    }

    if (control.errors['invalidEgyptOrKsaPhone']) {
      return this.isAr
        ? `${label} لازم يكون رقم موبايل مصري أو سعودي صحيح`
        : `${label} must be a valid Egyptian or Saudi mobile number`;
    }

    if (control.errors['arabicNotAllowed']) {
      return this.isAr
        ? `${label} لازم يكون بأرقام إنجليزية بدون حروف عربية`
        : `${label} must use English digits without Arabic characters`;
    }

    return this.isAr ? `${label} غير صحيح` : `${label} is invalid`;
  }

  getMissingRequiredCount(): number {
    if (!this.data) {
      return 0;
    }

    return Object.keys(this.data.controls).filter((controlName) => {
      const control = this.data.get(controlName);
      return control?.hasError('required');
    }).length + (this.hasNoSelectedItems() ? 1 : 0);
  }

  private validateBeforeSubmit(): boolean {
    this.submitted = true;

    if (this.data.invalid || this.hasNoSelectedItems() || this.hasInvalidSelectedItems()) {
      this.data.markAllAsTouched();

      Swal.fire({
        icon: 'warning',
        title: this.isAr ? 'تأكد من بيانات الاوردر' : 'Please check order data',
        text: this.isAr ? 'راجع الرسائل تحت الحقول المطلوبة أو غير الصحيحة' : 'Review the messages below the required or invalid fields',
        confirmButtonText: this.isAr ? 'تمام' : 'OK',
      });

      return false;
    }

    return true;
  }

  // ===============================
  // Data Loading Methods
  // ===============================
  getAllStockData(): void {
    const posId = localStorage.getItem('posId');
    if (!posId) return;
    this._orderService.getStocksData(posId).subscribe({
      next: (data) => {
        this.productname = data.stocks
          .filter((item: StockItem) => Number(item.quantity) > 0)
          .sort((a: StockItem, b: StockItem) =>
            a.name_ar.localeCompare(b.name_ar, 'ar', { sensitivity: 'base' })
          );
        this.filteredProviders = [...this.productname];
        if (this.inUpdatePage) {
          this.buildSelectedProductsFromParams();
        }
      },
      error: (error) => console.error('Failed to load stock data:', error),
    });
  }

  getAllUsers(): void {
    this.contentReady = true;
    this._homeService.getAllUsers().subscribe({
      next: (data) => {
        this.users = this.filterUsersByType(data.reverse());
        this.contentReady = false;
      },
      error: (error) => console.error('Failed to load users:', error),
    });
  }

  loadGovernorates(): void {
    this.contentReady = true;
    this.governoratesService.getAllGovernorates().subscribe({
      next: (data) => {
        this.governorates = data;
        this.contentReady = false;
      },
      error: (err) => console.error('Failed to load governorates:', err),
    });
  }

  loadCities(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const governorateId = Number(selectElement.value);
    if (!governorateId) {
      this.cities = [];
      return;
    }
    this.governoratesService.getCity(governorateId).subscribe({
      next: (res) => {
        this.cities = res;
        this.contentReady = false;
      },
      error: (err) => {
        console.error('Error loading cities', err);
        this.cities = [];
      }
    });
  }

  loadWarehouseType(): void {
    if (!this.warehouseId) return;
    this._userService.getWarehouseType(Number(this.warehouseId)).subscribe({
      next: (data) => {
        this.warehouseIsStore = data['warehouses_type'] === '1';
      }
    });
  }

  // ===============================
  // User & Account Methods
  // ===============================
  getUserId(): void {
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.thisUserId = data['user_id'];
      },
      error: (error) => console.error('Failed to get user ID:', error),
    });
  }

  checkAccountType(): string {
    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accounttype = data['user_type'];
        if (this.accounttype === '1' || this.accounttype === '6') {
          this.showAllUsers = true;
        }
      },
      error: (error) => console.error('Failed to get account type:', error),
    });
    return this.accounttype ?? '';
  }

  filterUsersByType(users: users[], typeToMatch: string = this.thisUserId): users[] {
    return users.filter(user => user.id !== typeToMatch);
  }



  onitemchange(input: string): void {
    const match = input.match(/^(\d+)type(\d+)$/);
    if (match) {
      const [, id, type] = match;
      this.createOrderByid = id;
      this.createOrderByidType = type;
    } else {
      console.error('Input format is invalid.');
    }
  }

  openSelect(): void {
    this.mySelect?.open();
  }

  // ===============================
  // Cart & Client Restoration
  // ===============================
  private restoreCartFromStorage(): void {
    const storedCart = localStorage.getItem('cart');
    if (storedCart && storedCart !== '[]') {
      try {
        const cartItems = JSON.parse(storedCart);
        this.applyCartItems(cartItems);
      } catch (error) {
        console.error('Invalid stored cart data:', error);
        localStorage.removeItem('cart');
        localStorage.removeItem('cartWarehouseId');
      }
    }
  }

  private restoreClientFromStorage(): void {
    const storedClient = localStorage.getItem('clientinfo');
    if (storedClient) {
      this.clearClientBtn = true;
      const client = JSON.parse(storedClient);
      this.client_name = client['client_name'] ?? '';
      this.phone_number = client['phone_number'] ?? '';
      this.another_phone = client['another_phone'] ?? '';
      this.address = client['address'] ?? '';
    }
  }

  private handleQueryParamCart(): void {
    this.route.queryParams.subscribe(params => {
      const cartParam = params['cart'];
      if (cartParam) {
        try {
          const cartItems = JSON.parse(cartParam);
          this.warehouseId = params['warehouseIdFromCart'] ?? this.warehouseId;
          console.log('Received cart from query params:', this.warehouseId);
          this.applyCartItems(cartItems);
        } catch (error) {
          console.error('Invalid cart data:', error);
        }
      }
    });
  }

  private applyCartItems(cartItems: StockItem[]): void {
    this.cartItems = Array.isArray(cartItems) ? cartItems : [];
    this.clearcart = this.cartItems.length > 0;
    this.selectedValueFromStock = this.cartItems.length === 0;
    this.selectedProductsDetails = this.cartItems.map((item: StockItem) => ({
      product: item,
      quantity: 1,
      price: this.getProductPriceByAccountType(item),
      bounes: null
    }));
  }

  // ===============================
  // Order Submission Logic
  // ===============================
  submitSelectedProducts(): void {
    this.arrayofitems = [];
    this.arrayofids = [];
    this.arrayofprices = [];
    this.arrayofqty = [];
    this.arrayofOlditems = [];
    this.arrayofbounes = [];
    this.totalOriginalPrice = 0;
    this.totalUserEnteredPrice = 0;

    for (const item of this.selectedProductsDetails) {
      const product = item.product;
      const quantity = item.quantity ?? 0;
      const enteredPrice = item.price ?? 0;
      const bounes = item.bounes ?? 0;

      this.originalPrice = this.getProductPriceByAccountType(product);
      this.arrayofOlditems.push(this.originalPrice);
      this.arrayofitems.push(product.name_ar);
      this.arrayofids.push(product.id);
      this.arrayofprices.push(enteredPrice);
      this.arrayofqty.push(quantity);
      this.arrayofbounes.push(bounes);

      this.totalOriginalPrice += this.originalPrice * quantity;
      this.totalUserEnteredPrice += enteredPrice * quantity;
    }

    this.income = this.totalOriginalPrice;
    if (this.accounttype === '2') {
      this.due = Math.round(this.totalUserEnteredPrice) - Math.round(this.totalOriginalPrice);
    } else {
      if (this.createOrderByid != null && this.createOrderByidType === '2') {
        this.due = Math.round(this.totalUserEnteredPrice) - Math.round(this.totalOriginalPrice);
      } else {
        this.due = '';
      }
    }
    this.total = this.totalUserEnteredPrice;
  }

  private appendPostData(): void {
    this.total = Number(this.total) || 0;
    this.dataForm = new FormData();
    this.dataForm.append('client_name', this.client_name);
    this.dataForm.append('phone_number', this.phone_number);
    this.dataForm.append('another_phone', this.another_phone);
    this.dataForm.append('total', String(this.total + parseInt(this.delivery_fees || '0')));
    this.dataForm.append('income', String(this.income));
    this.dataForm.append('address', this.address);
    this.dataForm.append('grov_id', String(this.government_id));
    this.dataForm.append('city_id', String(this.city_id));
    this.dataForm.append('note', this.note || '');

    this.dataForm.append('delivery_fees', this.delivery_fees || '0');
    for (let i = 0; i < this.arrayofitems.length; i++) {

      this.dataForm.append('item[]', this.arrayofitems[i]);

      this.dataForm.append('quantity[]', String(this.arrayofqty[i]));

      this.dataForm.append('price[]', String(this.arrayofprices[i]));

      this.dataForm.append('itemsprices[]', String(this.arrayofOlditems[i]));

      this.dataForm.append('product_id[]', String(this.arrayofids[i]));


      this.dataForm.append('bonuses[]', String(this.arrayofbounes[i] ?? 0));


    }


    this.dataForm.append('order_status', '1');
    this.dataForm.append('user_id', this.createOrderByid ?? this.thisUserId);
    this.dataForm.append('due', String(this.due));
    this.dataForm.append('duenow', String(this.due));
    this.dataForm.append('warehouse_id', String(this.warehouseId));
  }

  // ===============================
  // Action Methods
  // ===============================
  onSubmit(): void {
    if (!this.validateBeforeSubmit()) {
      return;
    }

    this.contentReady = true;
    this.submitSelectedProducts();
    this.appendPostData();
    this._orderService.addOrder(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'اوردرك قيد الانتظار' : 'Order Placed',
          showConfirmButton: false,
          timer: 1500,
        });
        this.contentReady = false;
        localStorage.removeItem('cart');
        localStorage.removeItem('cartWarehouseId');
        localStorage.removeItem('clientinfo');
        if (this.hasQrOffer) {
          this.generateQr(res['order'].id, res['client'].id, this.thisUserId);
        }
        this.router.navigateByUrl(this.isMobile ? '/orders.mobile' : '/Orders');
      },
      error: (err) => {

        let backendError = err?.error?.error || err?.error?.message || '';

        let message = backendError;

        if (backendError.includes('Not enough stock')) {

          const productId = backendError.match(/\d+/)?.[0];

          message = this.isAr
            ? `لا يوجد مخزون كافي للمنتج رقم ${productId}`
            : `Not enough stock for product ID ${productId}`;

        }

        Swal.fire({
          icon: 'error',
          title: message || (this.isAr ? 'فشل حفظ الاوردر' : 'Order Failed'),
          confirmButtonText: this.isAr ? 'تمام' : 'OK'
        });

        this.contentReady = false;
      },
    });
  }

  updateOrder(): void {
    if (!this.validateBeforeSubmit()) {
      return;
    }

    this.contentReady = true;
    this.submitSelectedProducts();
    this.appendPostData();
    this._orderService.updateOrder(this.updateId, this.dataForm).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'اوردرك قيد الانتظار' : 'Order Placed',
          showConfirmButton: false,
          timer: 1500,
        });
        this.contentReady = false;
        localStorage.removeItem('cart');
        localStorage.removeItem('cartWarehouseId');
        localStorage.removeItem('clientinfo');
        this.router.navigateByUrl(this.isMobile ? '/orders.mobile' : '/Orders');
      },
      error: () => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'فشل حفط الاوردر' : 'Order Failed',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });
        this.contentReady = false;
      },
    });
  }

  clearClient(): void {
    localStorage.removeItem('clientinfo');
    this.clearClientBtn = false;
    this.client_name = '';
    this.phone_number = '';
    this.another_phone = '';
    this.address = '';
  }

  clearProduct(): void {
    localStorage.removeItem('cart');
    localStorage.removeItem('cartWarehouseId');
    this.clearcart = false;
  }

  buildSelectedProductsFromParams(): void {
    this.selectedProductsDetails = [];
    for (let i = 0; i < this.arrayofids.length; i++) {
      const id = +this.arrayofids[i]!;
      const name = this.arrayofitems[i];
      const qty = +this.arrayofqty[i]!;
      const price = +this.arrayofprices[i]!;
      const bounes = +this.arrayofbounes[i];
      const product = this.filteredProviders.find(p => p.id === id);
      if (product) {
        this.selectedProductsDetails.push({
          product,
          quantity: qty,
          price: price,
          bounes: bounes || null
        });
      } else {
        console.warn(`⛔ Skipping index ${i} due to missing product`, { id, name, qty, price });
      }
    }

    this.contentReady = false;
  }

  generateQr(id: any, clientId: any, userId: any): void {
    const orderLink = `${window.location.origin}/Addorderclient?orderId=${id}&cart=${encodeURIComponent(JSON.stringify(this.arrayofids))}&client=${encodeURIComponent(clientId)}&prices=${encodeURIComponent(JSON.stringify(this.arrayofprices))}&page_id=${encodeURIComponent(userId)}`;
    console.log('Generated QR Link:', orderLink);
    this._orderService.generateLinkQr(orderLink, id).subscribe({
      next: (data) => console.log('QR Generated ✅:', data),
      error: (error) => console.error('QR Error ⛔:', error),
    });
  }
}
